import { render, staticRenderFns } from "./CkycApproveDetails.vue?vue&type=template&id=0cacd4fc&scoped=true&"
import script from "./CkycApproveDetails.vue?vue&type=script&lang=js&"
export * from "./CkycApproveDetails.vue?vue&type=script&lang=js&"
import style0 from "./CkycApproveDetails.vue?vue&type=style&index=0&id=0cacd4fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cacd4fc",
  null
  
)

export default component.exports